import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Card,
  CardMedia,
  Paper,
  TextField,
  IconButton,
  Avatar,
  MenuItem,
  InputAdornment,
  createTheme,
  Modal,
  Dialog,
} from "@mui/material";
import {
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share";
import {
  WhatsappIcon,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from "react-share";
import {
  Card as AntCard,
  Select,
  Checkbox,
  Divider,
  notification,
  QRCode,
} from "antd";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import eventCardDefaultIMG from "../../../../Images/EventCardDefaultIMG.jpg";

import { Close, Group, Margin } from "@mui/icons-material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import "./textTransition.css";
import {
  useBookingDetailsMutation,
  useSearchEventByIdMutation,
} from "../../../../Redux/apis/ApiSlice";
import dayjs from "dayjs";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import html2canvas from "html2canvas";

const { Option } = Select;
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560, // Custom breakpoint for 4K screens
    },
  },
});
const EventCard = ({ image, altText }) => {
  return (
    <Card sx={styles.card}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        {/* Blurred Background */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(10px)",
            zIndex: 1,
          }}
        />

        {/* Centered Main Image */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            zIndex: 2,
          }}
        >
          <CardMedia
            component="img"
            image={image}
            alt={altText}
            sx={{
              maxHeight: "100%",
              objectFit: "contain", // Scales proportionally
            }}
          />
        </Box>
      </Box>
    </Card>
  );
};

const EventDetail = ({ paramId }) => {
  const { eventId } = useParams();

  const [searchEventById, { data, isLoading, isError, refetch }] =
    useSearchEventByIdMutation();
  const payloadTax = { eventId: paramId ? paramId : eventId };
  const location = useLocation();
  const navigate = useNavigate();
  const [ticketSummary, setTicketSummary] = useState({});
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const [maxQuantity, setMaxQuantity] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState("");
  const userData = localStorage.getItem("userData");
  const parsedData = JSON.parse(userData);
  const [event, setEvent] = useState({});
  const qrRef = useRef();
  const queryParams = new URLSearchParams(location.search);
  const senderEncoded = queryParams.get("sender");
  const sender = senderEncoded ? Number(atob(senderEncoded)) : null;

  const handleDownload = async () => {
    const element = qrRef.current;
    const canvas = await html2canvas(element);
    const dataURL = canvas.toDataURL("image/png");

    // Set to modal view
    setSelectedImage(dataURL);
    setOpen(true);

    // Optional: trigger download too
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = "qr-with-text.png";
    link.click();
  };

  // Extract the id
  const userId = parsedData?.id;
  const fetchEventDetails = async () => {
    try {
      const response = await searchEventById(payloadTax).unwrap();
      setEvent(response);
    } catch (error) {
      // handle error
    }
  };

  useEffect(() => {
    fetchEventDetails();

    if (event?.ticket) {
      const tickets = event.ticket || [];
      const ticketSummary = {};
      tickets.forEach((ticket) => {
        ticket.subTickets.forEach((subTicket) => {
          const { ticketType, quantity, price } = subTicket;
          const typeName = ticketType.typeName;

          if (!ticketSummary[typeName]) {
            ticketSummary[typeName] = {
              quantity: 0,
              price: 0,
            };
          }

          ticketSummary[typeName].quantity += quantity;
          ticketSummary[typeName].price = price;
        });
      });
      const availableTickets = Object.entries(ticketSummary)
        .filter(([, { quantity }]) => quantity > 0)
        .reduce((acc, [typeName, { quantity, price }]) => {
          acc[typeName] = { quantity, price };
          return acc;
        }, {});
      setTicketSummary(availableTickets);
      if (Object.keys(availableTickets).length > 0) {
        setSelectedTicket(Object.keys(availableTickets)[0]);
      }
    }
  }, []);

  useEffect(() => {
    if (!event?.ticket) return;

    const ticketSummary = {};
    event.ticket.forEach((ticket) => {
      ticket.subTickets.forEach(({ ticketType, quantity, price }) => {
        const typeName = ticketType.typeName;
        if (!ticketSummary[typeName]) {
          ticketSummary[typeName] = { quantity: 0, price: 0 };
        }
        ticketSummary[typeName].quantity += quantity;
        ticketSummary[typeName].price = price;
      });
    });

    const availableTickets = Object.entries(ticketSummary)
      .filter(([, { quantity }]) => quantity > 0)
      .reduce((acc, [typeName, details]) => {
        acc[typeName] = details;
        return acc;
      }, {});

    setTicketSummary(availableTickets);
    if (Object.keys(availableTickets).length > 0) {
      setSelectedTicket(Object.keys(availableTickets)[0]);
    }
  }, [event]);
  const handleClickBook = () => {
    const eventStart = dayjs(event?.startDateTime);
    const eventEnd = dayjs(event?.endDateTime);
    const currentTime = dayjs();
    // console.log("pupiuy", event);

    // Check if there are no tickets or if all subTickets have quantity 0
    const hasAvailableSubTickets = event?.ticket?.some((ticket) =>
      ticket?.subTickets?.some((subTicket) => subTicket?.quantity > 0)
    );

    if (!hasAvailableSubTickets) {
      // Show notification if all subTickets are fully booked (quantity is 0)
      notification.error({
        message: "This event is fully booked!",
      });
      return;
    }

    if (eventEnd.isBefore(currentTime)) {
      notification.info({
        message: "Event time expired!",
      });
      return;
    }

    navigate("/ticket-booking", {
      state: { event, ticketSummary, invitationId: sender },
    });
  };

  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);
  };
  const handleSelectChange = (event) => {
    const typeName = event.target.value;
    setSelectedTicket(typeName);
    setSelectedQuantity(0); // Start at 0 when a new ticket is selected
    setMaxQuantity(ticketSummary[typeName]?.quantity || 0);
  };

  // Calculate subtotal based on selected quantity and ticket price
  const price = ticketSummary[selectedTicket]?.price || 0;
  const subtotal = selectedQuantity * price;
  const SetViewOnMarker = ({ coords }) => {
    const map = useMap();
    if (
      coords &&
      coords.length === 2 &&
      coords[0] !== null &&
      coords[1] !== null
    ) {
      map.setView(coords, map.getZoom());
    }
    return null;
  };
  const truncateText = (text, maxWords) => {
    const words = text?.split(" ");
    return words.length > maxWords
      ? words.slice(0, maxWords).join(" ") + "..."
      : text;
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleShare = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const eventLink = `https://gxtickets.com/detail/${
    paramId ? paramId : eventId
  }`; // Dynamically constructed URL

  const handleCopyLink = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(eventLink) // Copy the link to clipboard
        .then(() => {
          notification.success({
            message: "Link copied!",
            // description: "Link copied to clipboard!",
          });
        })
        .catch((err) => {
          notification.error({
            message: "Failed to copy!",
            // description: "Could not copy the link to clipboard.",
          });
          console.error("Copy failed", err);
        });
    } else {
      notification.error({
        message: "Clipboard not supported!",
        // description: "Your browser does not support clipboard operations.",
      });
      console.error("Clipboard API not supported");
    }
  };

  const XIcon = () => (
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/5/53/X_logo_2023_original.svg"
      alt="X (Twitter) logo"
      width={32}
      height={32}
      style={{ borderRadius: "50%" }}
    />
  );

  const eventPhotos =
    Array.isArray(event?.eventPhoto) && event.eventPhoto.length > 0
      ? ["qr", ...event.eventPhoto]
      : ["qr"];

  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // Open Fullscreen Mode
  const handleImageOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  // Close Fullscreen Mode
  const handleImageClose = () => {
    setOpen(false);
  };

  const sliderRef = useRef(null);
  const eventPhotosCount = eventPhotos?.length;
  const slidesToShow =
    eventPhotosCount === 1 ? 1 : eventPhotosCount === 2 ? 2 : 3;
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: eventPhotosCount > 1 ? true : false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: eventPhotosCount === 1 ? 1 : 2,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px",
        },
      },
    ],
    appendDots: (dots) => (
      <Box
        sx={{
          textAlign: "center",
          bottom: -100,
          "& li.slick-active div:first-of-type": {
            backgroundColor: "#333",
          },
        }}
      >
        <ul style={{ marginTop: "0px", padding: "0px", fontSize: "2rem" }}>
          {" "}
          {dots}{" "}
        </ul>
      </Box>
    ),
    customPaging: () => (
      <Box
        sx={(theme) => ({
          width: "10px",
          height: "10px",
          backgroundColor: "#bbb",
          borderRadius: "50%",
          display: "inline-block",
          margin: "5px",
          transition: "all 0.3s ease",
        })}
      />
    ),
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#000",
          width: "100%",
          minHeight: { xs: "300px", md: "400px" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          position: "relative",
          overflow: "hidden",

          p: 2,
        }}
      >
        {/* Event Title */}
        <Typography
          variant="h4"
          sx={{
            my: 2,
            fontWeight: 600,
            fontSize: { xs: "24px", md: "36px" },
            color: "white",
            zIndex: 10,
            textAlign: "center",
          }}
        >
          {event?.eventName || "Event Title"}
        </Typography>
      </Box>

      <Container
        maxWidth="lg"
        sx={{
          width: "100%",
          px: 5,
          position: "relative",
          marginTop: { md: "-250px", xs: "-200px" },
          marginBottom: { xs: 5, md: 10 },
        }}
      >
        <Slider ref={sliderRef} {...settings}>
          {eventPhotos.map((image, index) => (
            <Box key={index} sx={{ px: 2 }}>
              <Box
                sx={{
                  p: { xs: 2, lg: 4 },
                  textAlign: "left",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  margin: "auto",
                  width: { xs: "100%", lg: "350px" },
                  boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.08)",
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  "&:hover": {
                    boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.12)",
                    transform: "translateY(-5px)",
                  },
                  position: "relative",
                }}
              >
                <Box
                  // onClick={() => handleImageOpen(image)}
                  onClick={async () => {
                    if (image === "qr") {
                      const canvas = await html2canvas(qrRef.current, {
                        scale: 5, // 3x resolution — you can tweak this
                        useCORS: true, // allows image/icon loading
                      });

                      const dataURL = canvas.toDataURL("image/png");
                      handleImageOpen(dataURL);
                    } else {
                      handleImageOpen(image); // normal photo
                    }
                  }}
                  sx={{
                    height: { xs: "320px", sm: "350px" },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {image === "qr" ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ backgroundColor: "white" }} ref={qrRef}>
                          <QRCode
                            value={eventLink}
                            size={300}
                            icon="/GX_Logo_Black_No_Bg.png" // optional: your logo
                            bordered={false}
                            color="#000"
                            errorLevel="H"
                          />
                          <Typography
                            variant="body1"
                            sx={{ mt: 2, textAlign: "center" }}
                          >
                            {event?.eventName || "Event Name"}
                          </Typography>
                        </Box>
                        <Button onClick={handleDownload}>Download</Button>
                      </Box>
                    </>
                  ) : (
                    <>
                      {/* Blurred Background */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundImage: `url(${image})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          filter: "blur(30px)",
                          opacity: 0.3,
                          zIndex: 1,
                        }}
                      />
                      {/* Main Image */}
                      <CardMedia
                        component="img"
                        image={image}
                        alt={`Event Image ${index + 1}`}
                        sx={{
                          position: "relative",
                          zIndex: 2,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />{" "}
                    </>
                  )}
                </Box>
              </Box>
            </Box>
          ))}
        </Slider>
      </Container>

      {/* Fullscreen Image Dialog */}
      <Dialog open={open} onClose={handleImageClose} maxWidth="lg" fullScreen>
        <Box
          sx={{
            backgroundColor: "#000",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            position: "relative",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleImageClose}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              color: "white",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.4)",
              },
            }}
          >
            <Close fontSize="large" />
          </IconButton>

          <CardMedia
            component="img"
            image={selectedImage}
            sx={{
              maxWidth: "500px", // limit the image width
              width: "100%",
              height: "auto",
              objectFit: "contain",
              borderRadius: 2,
            }}
          />
        </Box>
      </Dialog>

      <Divider />

      <Grid
        container
        spacing={{ xs: 2, md: 0 }}
        sx={{ mb: { xs: 2, md: 10 }, ...styles.contentGridContainer }}
      >
        <Grid item xs={12} lg={8} md={6}>
          <Container maxWidth="md" sx={{ paddingBottom: 2 }}>
            <Box mb={2} mt={2}>
              <Grid container spacing={2}>
                {/* Organization Details */}
                <Grid item xs={12} md={6} lg={4}>
                  <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
                    Organization Name
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {event?.organizationName}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
                    Event Location
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {event?.location}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, fontSize: 15 }}
                  >
                    Owner Name
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Avatar sx={{ height: 25, width: 25 }} />
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      {event?.eventOrganizers?.[0]?.user?.fullName ||
                        "Organizer Name"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Divider />
            {/* <Box p={1}>
              {/* <Typography
                sx={{

                  fontWeight: 600,
                  fontSize: 20,
                  cursor: "pointer",
                }}
              >
                More Details
              </Typography> 
            </Box> */}
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 15,
                }}
                gutterBottom
                onClick={handleClick}
              >
                Description
              </Typography>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  {event?.description}
                </Typography>
              </Box>
            </Box>
            <Divider />

            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 15,
              }}
              gutterBottom
            >
              Approximate location
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              You'll get detailed location instructions when you make a booking.
            </Typography>

            <MapContainer
              center={
                event?.latitude && event?.longitude
                  ? [event?.latitude, event?.longitude]
                  : [51.505, -0.09]
              }
              zoom={2}
              style={styles.mapContainer}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              />
              {event?.latitude && event?.longitude && (
                <>
                  <Marker position={[event?.latitude, event?.longitude]}>
                    <Popup>{event?.location}</Popup>
                  </Marker>
                  <SetViewOnMarker
                    coords={[event?.latitude, event?.longitude]}
                  />
                </>
              )}
            </MapContainer>
          </Container>
        </Grid>
        <Grid item xs={12} lg={4} md={6}>
          <Container maxWidth="xs">
            <Paper sx={styles.cardPaper}>
              <AntCard style={{ height: "100%" }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    mt: 2,
                  }}
                >
                  Available ticket categories
                </Typography>
                <div>
                  <TextField
                    select
                    value={selectedTicket}
                    onChange={handleSelectChange}
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#2E728F",
                      mt: 2,
                    }}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Group sx={{ color: "#2E728F" }} />
                        </InputAdornment>
                      ),
                    }}
                  >
                    {Object.entries(ticketSummary).length === 0 ? (
                      <MenuItem disabled>No tickets available</MenuItem>
                    ) : (
                      Object.entries(ticketSummary).map(
                        ([typeName, { quantity, price }]) => (
                          <MenuItem key={typeName} value={typeName}>
                            {typeName}: ${price}
                            {/* Quantity: {quantity}, Price:  */}
                          </MenuItem>
                        )
                      )
                    )}
                  </TextField>
                </div>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    ...styles.bookButton,
                    "&:hover": {
                      backgroundColor: "var(--primary-color)",
                    },
                  }}
                  onClick={handleClickBook}
                >
                  Purchase
                </Button>
                {/* {paramId && ( */}
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    ...styles.bookButton,
                    backgroundColor: "var(--primary-color)",
                    "&:hover": {
                      backgroundColor: "var(--secondary-color)",
                    },
                  }}
                  onClick={handleShare}
                >
                  Share
                </Button>
                {/* )} */}
              </AntCard>
            </Paper>
          </Container>
        </Grid>
        <Modal
          open={modalOpen}
          onClose={handleClose}
          aria-labelledby="shareable-link-title"
          aria-describedby="shareable-link-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 1,
              textAlign: "center",
              borderRadius: "8px",
            }}
          >
            <Typography
              id="shareable-link-title"
              variant="h6"
              component="h2"
              sx={{ mb: 2 }}
            >
              Shareable Link
            </Typography>
            <div style={{ marginBottom: "10px" }}>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Share this link with others:
              </Typography>
              <Button variant="outlined" onClick={handleCopyLink}>
                Copy Link
              </Button>
            </div>

            <div
              style={{
                marginTop: "10px",
                display: "flex",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              {/* WhatsApp */}
              <WhatsappShareButton
                url={eventLink}
                title={`🎉 Check out this amazing event!\n\n📌 Event: ${event?.eventName}\n📍 Location: ${event?.location}\n\n🔗 Join here:`}
              >
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>

              {/* Facebook */}
              {/* <FacebookShareButton
                url={eventLink}
                quote={"Check out the event:"}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton> */}

              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  eventLink
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon size={32} round />
              </a>

              {/* Twitter */}
              <TwitterShareButton
                url={eventLink}
                title={`Check out this amazing event!\n📌Event: ${event?.eventName}\n📍Location: ${event?.location}\nJoin here:`}
                hashtags={["Event", "Tickets", "JoinUs"]}
              >
                {/* <TwitterIcon size={32} round /> */}
                <XIcon />
              </TwitterShareButton>

              {/* LinkedIn */}
              <LinkedinShareButton
                url={eventLink}
                summary={"Check out the event:"}
              >
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
              {/* Email */}
              <a
                href={`mailto:?subject=Check out this event&body=${
                  `🎉 Check out this amazing event!%0A%0A` +
                  `📌 Event: ${event?.eventName}%0A%0A` +
                  `📍 Location: ${event?.location}%0A%0A` +
                  encodeURIComponent(`🔗 Join here: ${eventLink}`) +
                  `%0A%0AHope to see you there! 🚀`
                }`}
                style={{ textDecoration: "none" }}
                title="Share via Email"
              >
                <img
                  src="https://img.icons8.com/ios-filled/50/000000/email.png"
                  alt="Email Icon"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                  }}
                />
              </a>
            </div>
          </Box>
        </Modal>
      </Grid>
    </>
  );
};

export default EventDetail;

const CustomPrevArrow = (props) => (
  <div
    {...props}
    style={{
      ...props.style,
      left: "-40px",
      zIndex: 10,
      color: "white",
      fontSize: "30px",
    }}
  >
    ◀
  </div>
);

const CustomNextArrow = (props) => (
  <div
    {...props}
    style={{
      ...props.style,
      right: "-40px",
      zIndex: 10,
      color: "white",
      fontSize: "30px",
    }}
  >
    ▶
  </div>
);

const styles = {
  headerBox: {
    // py: 4,
    // height: { xl: "80vh", lg: "700px",md:"50vh", xs: "700px" },
    bgcolor: "var(--primary-color)",
    color: "white",
    height: "700px", // Fixed height for consistency
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "100%",
  },
  containerCenter: {
    // display: "flex",
    // flexDirection: "column",
    // alignItems: "center",
    // padding: { md: 8, xs: 10, sm: 10 },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "40px",
    height: "100%",
  },
  gridContainer: {
    marginTop: {
      xs: -100,
      sm: "-0.938em",
      md: "-42.188em",
      lg: "-42.188em",
      xl: "-42.5em",
      xxl: "-52.5em",
    },
    // marginTop: "-20em",
    padding: { xs: 2, sm: 5, md: 15 },
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  card: {
    borderRadius: 6,
    height: "32vh",
  },
  cardLarge: {
    borderRadius: 6,
    // height: "600px", // Default height
    height: "100%", // Default height
  },
  cardMedia: {
    height: "100%",
    objectFit: "Fit",
    objectPosition: "center",
  },
  contentGridContainer: {
    padding: { xs: 2, sm: 5, lg: "0px 10px 0px 0px ", md: "0px 10px 0px 0px " },
    marginTop: 20,
  },
  mapContainer: {
    height: "300px",
    width: "100%",
  },
  cardPaper: {
    gap: 5,
    mb: 2,
    elevation: 5,
  },
  bookButton: {
    mt: 2,

    fontWeight: 600,
    fontSize: "16px",
    backgroundColor: "var(--secondary-color)",
    color: "white",
    outline: "none",
  },
  typographyMarginTop: {
    fontWeight: 400,
    fontSize: "16px",
  },
  checkboxMarginTop: {
    fontWeight: 400,
    fontSize: "14px",
  },
};
